module.exports = __webpack_public_path__ + "df0b586402822891d90b919cef21431c.woff2";